<section class="container-fluid px-0">

  <form [formGroup]="therapeuticCardsForm">
    <div style="display:none;">
      <input class="form-control form-control-sm" type="number" formControlName="patientCode" />
    </div>

    <div class="row">
      <!-- [ngClass]="{'disabledDiv': visitType == 1}" -->
      <div class="col-3" *ngIf="inTransferBodiesBeforeContract==1">
        <sanabel-selectize appcode="1277" (clicked)="inTransferClicked($event)"
          formControlName="inTransferBodiesSerial"></sanabel-selectize>
      </div>
      <!--  commented by basma 
        <div class="col-3" style="width: 33%;" *ngIf="integratesWithNaphisePlatform == 1">
        <label for="nphiesEligibilityTransferReference">
          {{ 'Nphies Eligibility Transfer Reference' | translate }}
        </label>
        <input class="form-control form-control-sm" formControlName="nphiesEligibilityTransferReference" />
      </div> --> 
      
      <div *ngIf="useOldContract ==1" class="col-md-1">
        <label>
          {{ 'DISPLAYALL' | translate }}
        </label>
        <input type="checkbox" (click)="displayAll()" name="displayAll">
      </div>

      <div class="col-12 col-sm-6 col-md-4" *ngIf="!displayAllInp && defaultOldContract && useOldContract == 1 ">
        <sanabel-selectize appcode="1410" [disabled]="!editable " formControlName="contractId" #contractSearch
          [tabindex]="tabindex" [SearchKeys]="{PatCode:defaultOldContract,contractType:contractTypeId}"
          (clicked)="contractClicked($event)">
        </sanabel-selectize>
      </div>

      <div class="col-12 col-sm-6 col-md-3" *ngIf="displayAllInp || useOldContract == 2">
        <sanabel-selectize appcode="1040" [disabled]="!editable " formControlName="contractId" #contractSearch
          [tabindex]="tabindex" [SearchKeys]="{PatCode:defaultOldContract,contractType:contractTypeId}"
          (clicked)="contractClicked($event)">
        </sanabel-selectize>
      </div>
      <!-- ! -->
      <div *ngIf="companyTypeFlag == 2" style="align-self: center;">
        <span class="fa fa-info-circle cursor-pointer text-info" style="font-size: 32px"
          (click)="companyChecklistPopup()"></span>
      </div>

      <div *ngIf="companyTypeFlag == 2  " [ngClass]="{'col-2': !portalReg, 'col-4': portalReg}">
        <label for="cardNo">
          {{ 'CARDNUMBER' | translate }}
        </label>
        <input class="form-control form-control-sm" type="text" (change)="onValuesChange()" formControlName="cardNo" />
      </div>

      <div *ngIf="companyTypeFlag == 2 " [ngClass]="{'col-2': !portalReg, 'col-4': portalReg}">
        <label>{{ 'StartDate' | translate }}</label>
        <div class="form-group">
          <div class="input-group input-group-sm">
            <input class="form-control" placeholder="{{'DATEFORMAT' | translate}}" (navigate)="onValuesChange()"
              (blur)="onValuesChange()" formControlName="startDate" name="dp" ngbDatepicker #dp="ngbDatepicker">
            <div class="input-group-addon" (click)="dp.toggle()">
              <i class="fa fa-calendar"></i>

            </div>
          </div>
        </div>
      </div>

      <div *ngIf="companyTypeFlag == 2  " [ngClass]="{'col-2': !portalReg, 'col-4': portalReg}">
        <label>{{ 'EndDate' | translate }}</label>
        <div class="form-group">
          <div class="input-group input-group-sm">
            <input class="form-control" placeholder="{{'DATEFORMAT' | translate}}" (navigate)="onValuesChange()"
              (blur)="onValuesChange()" name="d" formControlName="endDate" ngbDatepicker #d="ngbDatepicker">
            <div class="input-group-addon" (click)="d.toggle()">
              <i class="fa fa-calendar"></i>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="companyTypeFlag == 2  " [ngClass]="{'col-2': !portalReg, 'col-4': portalReg}">
        <label for="policyNumber">
          {{ 'PolicyNumber' | translate }}
        </label>
        <input class="form-control form-control-sm" type="text" (change)="onValuesChange()"
          formControlName="policyNumber" />
      </div>
      <!-- CRF -->
      <div *ngIf="showsFlag.crfFlag==1" [ngClass]="{'col-2': !portalReg, 'col-4': portalReg}">
        <div>{{'CRT' | translate}}</div>
        <div>
          <input [ngClass]="{ 'is-invalid': !crfFlagError, 'is-valid':crfFlagError }"
            class="form-control form-control-sm" type="text" (change)="onValuesChange()" formControlName="crf">
        </div>
      </div>
      <!-- DEB -->
      <div *ngIf="showsFlag.debFlag==1" [ngClass]="{'col-2': !portalReg, 'col-4': portalReg}">
        <div>{{'DEB' | translate}}</div>
        <div>
          <input [ngClass]="{ 'is-invalid': !debFlagError, 'is-valid':debFlagError }"
            class="form-control form-control-sm" type="text" (change)="onValuesChange()" formControlName="deb">
        </div>
      </div>

      <div [ngClass]="{'col-2': !portalReg, 'col-4': portalReg}">
        <label for="eligibilityNo">
          {{ 'EligibilityNo' | translate }}
        </label>
        <input class="form-control form-control-sm" type="number" (change)="onValuesChange()"
          formControlName="eligibilityNo" />
      </div>

      <div class="col-3" *ngIf="inTransferBodiesBeforeContract!=1">
        <sanabel-selectize appcode="1277" (clicked)="inTransferClicked($event)"
          formControlName="inTransferBodiesSerial"></sanabel-selectize>
      </div>
      <div class="col-1" style=" align-self: center;    text-align: center; ">
        <i style="margin-top: 22px;" class="fa fa-plus fa-2x AddButton" (click)="openinTransfer()" aria-hidden="true"
          placement="left" ngbTooltip="{{ 'ADD' | translate }}">
        </i>
      </div>



    </div>

    <div class="row"
      *ngIf="patSharingPercentFromCardFlag == 1 && registerMedicalCardDetailsWhenOpeningVisit==1 && !hideDataFromContract">
      <div class="col-sm-2">
        <div class="form-group">
          <label>{{ 'CONSULTATIONPERCENTORVALUE' | translate }}</label>
          <input type="number" class="form-control form-control-sm" formControlName="consultation"
            (change)="onValuesChange()">
        </div>
      </div>


      <div class="col-2">
        <sanabel-selectize appcode="40" (clicked)="onConsultationPercentOrValueClicked($event)"
          formControlName="consultationPercentOrValue"></sanabel-selectize>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label>{{ 'SERVICEPERCENT' | translate }}</label>
          <input type="number" class="form-control form-control-sm" formControlName="servicesPercent"
            (change)="onValuesChange()">
        </div>
      </div>

      <div class="col-sm-1" style="padding-top :30px ">
        <div class="form-group">
          <label class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" (change)="onValuesChange()"
              formControlName="glasessFlag" #glasessFlagcheckBox>
            <span class="custom-control-indicator"></span>
            <span class="custom-control-description">{{ 'GLASS' | translate }}</span>
          </label>
        </div>
      </div>

      <div class="col-sm-1" style="padding-top :30px ">
        <div class="form-group">
          <label class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" (change)="onValuesChange()"
              formControlName="pregnancyFollowUpFlag" #pregnancyFollowUpFlagcheckBox>
            <span class="custom-control-indicator"></span>
            <span class="custom-control-description">{{ 'PREGNANCYFOLLOWUP' | translate }}</span>
          </label>
        </div>
      </div>

      <div class="col-sm-1" style="padding-top :30px ">
        <div class="form-group">
          <label class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" (change)="onValuesChange()"
              formControlName="dentalConsultationFlag" #dentalConsultationFlag>
            <span class="custom-control-indicator"></span>
            <span class="custom-control-description">{{ 'DENTALCONSULTATION' | translate }}</span>
          </label>
        </div>
      </div>
      <div class="col-sm-1" style="padding-top :30px ">
        <div class="form-group">
          <label class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" (change)="onValuesChange()"
              formControlName="dentalServicesFlag" #dentalServicesFlag>
            <span class="custom-control-indicator"></span>
            <span class="custom-control-description">{{ 'DENTALSERVICE' | translate }}</span>
          </label>
        </div>
      </div>
    </div>

    <div class="container text-sm-center" style="margin-top: 20px;" *ngIf="contractClickedBool">
      <div class="row">
        <div class="col-sm">
          <label for="" style="text-decoration:underline;font-weight: bold;">
            {{translate.currentLang == 'ar' ? priPricingItemsNameAr :priPricingItemsNameEn}}
            <p style="display: inline ;margin: 0px 5px 0px 5px;">:</p>
          </label>
          <span>{{discountValue}}%</span>
        </div>

        <div class="col-sm">
          <label for="" style="text-decoration:underline;font-weight: bold;">{{ 'DEFRAY' | translate }}
            <p style="display: inline; margin: 0px 5px 0px 5px;">:</p>
          </label>
          <span>{{patShareValue}}</span>
        </div>

        <div class="col-sm">
          <label for="" style="text-decoration:underline;font-weight: bold;">{{ 'BENEFITKIND' | translate }}
            <p style="display: inline; margin: 0px 5px 0px 5px;">:</p>
          </label>
          <span> {{translate.currentLang == 'ar' ? discountOwnerNameAr :discountOwnerNameEn}} </span>
        </div>

      </div>
    </div>
  </form>

</section>
<div>
  <block-modal-container #popup (close)="onpopupClose($event)">
    <ng-container class="modal-body" [ngComponentOutlet]="dynamicComponent"></ng-container>
  </block-modal-container>
</div>
<div>
  <block-modal-container #content (close)=onModalClose($event)>
    <ng-container class="modal-body">
      <div class="info">
        <div style="text-align: center;text-decoration: underline;    color: red;">
          <h3>{{translate.currentLang=='ar'?'شروط التعاقد':'Contract terms'}}</h3>
        </div>
        <ul style="padding-right: 31px; font-size: 17px;">
          <li *ngFor="let item of arrCompanyCheckList">{{item.conditionAsAText}}</li>
        </ul>
      </div>
    </ng-container>
  </block-modal-container>
</div>